import React from "react";
import {Card, Form} from "react-bootstrap";
import ValidationHelper from "../../../../../../helpers/ValidationHelper";
import { withTranslation } from "react-i18next";
import BaseDialog from "../../../../../../components/dialogs/baseDialog/BaseDialog";
import BaseSelect from "../../../../../../components/baseSelect/BaseSelect";

class CreateIsolationHardware extends React.Component {
    constructor(props) {
        super(props);

        this.validationDefinition = {
            identifier: {
                defaultValue: "",
                rule: ValidationHelper.isString
            },
            product: {
                defaultValue: "",
                rule: ValidationHelper.isString
            },
            type: {
                defaultValue: 1,
                rule: value => ValidationHelper.isInt(value) && value >= 0 && value <= 1
            },
            serialNumber: {
                defaultValue: "",
                rule: ValidationHelper.isString
            },
            osVersion: {
                defaultValue: "",
                rule: ValidationHelper.isTestedOS
            }
        };

        this.state = {
            validation: ValidationHelper.getValidation(this.validationDefinition),
            scannerIsRunning: false,
            stagedDevice: null
        };

        this.types = [
            {label: "USB 3.0", value: 1},
            {label: "USB 2.0", value: 0}
        ];

        this.handleChange = this.handleChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onHide = this.onHide.bind(this);

        this.scannerRef = React.createRef();
    }

    handleChange(event) {
        this.setState({
            validation: ValidationHelper.update(event, this.state.validation)
        });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.show !== this.props.show) {
            this.setState({
                validation: ValidationHelper.getValidation(this.validationDefinition)
            });
        }

    }

    handleScanStart(callback) {
        this.setState({ scannerIsRunning: true, stagedDevice: null }, callback);
    }

    onHide() {
        this.props.onHide(ValidationHelper.hasChanged(this.state.validation));
    }

    onSubmit() {
        if (this.state.validation._isValid) {
            const validatedData = ValidationHelper.getData(this.state.validation);
            this.props.onSubmit(validatedData);
        }
    }

    render() {
        const { t } = this.props;
        return (
            <BaseDialog
                show={this.props.show}
                onHide={this.onHide}
                rightButtonCallback={this.onSubmit}
                title={t("Hardware.Tabs.IsolationHardware.Modal.Create.Title")}
                rightButtonText={t("Hardware.Tabs.IsolationHardware.Modal.Create.Form.Create")}
                leftButtonText={t("DialogCancel")}
                rightButtonVariant="green"
                leftButtonVariant="black"
                leftButtonCallback={this.onHide}
                dialogApiError={this.props.dialogApiError}
                rightButtonDisabled={!this.state.validation._isValid}
                body={(<Form onSubmit={this.onSubmit}>
                        <Card>
                            <Card.Body>
                                <Form.Group controlId="formIdentifier">
                                    <Form.Label>
                                        {t("Hardware.Tabs.IsolationHardware.Modal.Create.Form.Identifier")}
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="identifier"
                                        placeholder={t(
                                            "Hardware.Tabs.IsolationHardware.Modal.Create.Form.IdentifierPlaceholder"
                                        )}
                                        value={this.state.validation.identifier.value}
                                        isInvalid={!this.state.validation.identifier.isValid}
                                        onChange={this.handleChange}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {t("Hardware.Tabs.IsolationHardware.Modal.Create.Form.ValidationError.Identifier")}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId="formProduct">
                                    <Form.Label>
                                        {t("Hardware.Tabs.IsolationHardware.Modal.Create.Form.Product")}
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="product"
                                        placeholder={t(
                                            "Hardware.Tabs.IsolationHardware.Modal.Create.Form.ProductPlaceholder"
                                        )}
                                        value={this.state.validation.product.value}
                                        isInvalid={!this.state.validation.product.isValid}
                                        onChange={this.handleChange}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {t("Hardware.Tabs.IsolationHardware.Modal.Create.Form.ValidationError.Product")}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId="formType">
                                    <Form.Label>
                                        {t("Hardware.Tabs.IsolationHardware.Modal.Create.Form.Type")}
                                    </Form.Label>
                                    <BaseSelect
                                        onChange={s =>
                                            this.handleChange({
                                                target: {
                                                    name: "type",
                                                    value: s.value
                                                }
                                            })
                                        }
                                        options={this.types}
                                        placeholder={t(
                                            "Hardware.Tabs.IsolationHardware.Modal.Create.Form.Type"
                                        )}
                                    />
                                    <Form.Control
                                        type="hidden"
                                        isInvalid={!this.state.validation.type.isValid}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {t("Hardware.Tabs.IsolationHardware.Modal.Create.Form.ValidationError.Type")}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId="formSerialNumber">
                                    <Form.Label>
                                        {t("Hardware.Tabs.IsolationHardware.Modal.Create.Form.SerialNumber")}
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="serialNumber"
                                        placeholder={t(
                                            "Hardware.Tabs.IsolationHardware.Modal.Create.Form.SerialNumberPlaceholder"
                                        )}
                                        value={this.state.validation.serialNumber.value}
                                        isInvalid={!this.state.validation.serialNumber.isValid}
                                        onChange={this.handleChange}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {t("Hardware.Tabs.IsolationHardware.Modal.Create.Form.ValidationError.SerialNumber")}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId="formOsVersion">
                                    <Form.Label>
                                        {t("Hardware.Tabs.IsolationHardware.Modal.Create.Form.OsVersion")}
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="osVersion"
                                        placeholder={t(
                                            "Hardware.Tabs.IsolationHardware.Modal.Create.Form.OsVersionPlaceholder"
                                        )}
                                        value={this.state.validation.osVersion.value}
                                        isInvalid={!this.state.validation.osVersion.isValid}
                                        onChange={this.handleChange}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {t("Hardware.Tabs.IsolationHardware.Modal.Create.Form.ValidationError.OsVersion")}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Card.Body>
                        </Card>
                </Form>)}
            />
        );
    }
}

export default withTranslation()(CreateIsolationHardware);
